import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SqlStorageService {
  private dbName = 'SqliteFilesDB';
  private storeName = 'sqliteFiles';
  private db!: IDBDatabase;

  constructor() {
    this.initDB();
  }

  /** Initialize IndexedDB */
  private initDB(): void {
    const request = indexedDB.open(this.dbName, 1);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(this.storeName)) {
        db.createObjectStore(this.storeName);
      }
    };

    request.onsuccess = (event: Event) => {
      this.db = (event.target as IDBOpenDBRequest).result;
      console.log('IndexedDB initialized successfully');
    };

    request.onerror = (event: Event) => {
      console.error('Error opening IndexedDB:', event);
    };
  }

  /** Save a file buffer */
  saveFile(fileKey: string, buffer: ArrayBuffer): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.db) return reject('DB not initialized yet.');

      const tx = this.db.transaction([this.storeName], 'readwrite');
      const store = tx.objectStore(this.storeName);
      const request = store.put(buffer, fileKey);

      request.onsuccess = () => resolve();
      request.onerror = (err) => reject(err);
    });
  }

  /** Get a file buffer */
  getFile(fileKey: string): Promise<ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      if (!this.db) return reject('DB not initialized yet.');

      const tx = this.db.transaction([this.storeName], 'readonly');
      const store = tx.objectStore(this.storeName);
      const request = store.get(fileKey);

      request.onsuccess = (event: Event) => {
        const target = event.target as IDBRequest;
        resolve(target.result || null);
      };
      request.onerror = (err) => reject(err);
    });
  }

  /** Get all stored keys */
  getAllKeys(): Promise<string[] | Error> {
    return new Promise((resolve) => {
      if (!this.db) {
        const err = new Error('DB not initialized yet.');
        return resolve(err);
      }
      try {
        const tx = this.db.transaction([this.storeName], 'readonly');
        const store = tx.objectStore(this.storeName);
        const request = store.getAllKeys();
  
        request.onsuccess = (event: Event) => {
          const target = event.target as IDBRequest;
          resolve(target.result as string[]);
        };

        request.onerror = (err) => {
          resolve(err instanceof Error ? err : new Error('IndexedDB request error'));
        };
      } catch (err) {
        resolve(err instanceof Error ? err : new Error('Unexpected error in getAllKeys'));
      }
    });
  }
  // cleareverything in indexed db
  


  /** Clear all stored files */
  // clearAll(): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     if (!this.db) return reject('DB not initialized yet.');

  //     const tx = this.db.transaction([this.storeName], 'readwrite');
  //     const store = tx.objectStore(this.storeName);
  //     const request = store.clear();

  //     request.onsuccess = () => resolve();
  //     request.onerror = (err) => reject(err);
  //   });
  // }

  async  clearAll() {
  if (!('databases' in indexedDB)) {
    console.warn('indexedDB.databases() not supported in this browser.');
    return;
  }

  const databases = await indexedDB.databases();
  console.log(databases);
  

  for (const db of databases) {
    console.log(db.name);
    
    if (db.name) {
      console.log(`Deleting database: ${db.name}`);
      indexedDB.deleteDatabase(db.name);
    }
  }

  console.log('All IndexedDB databases deleted.');
}


       formatQueryOutput(result: any): string {
        if (!result[0].values || result[0].values.length === 0) {
          return '';
        }
    
        // Format output as rows separated by newlines
        return result[0].values.map((row: any[]) => row.join('\n')).join('\n\n');
      }
    
       compareOutputs(actual: string, expected: string): boolean {
        // Normalize whitespace and compare
        const normalizeString = (str: string) => 
          str.trim().replace(/\s+/g, ' ').toLowerCase();
        
        return normalizeString(actual) === normalizeString(expected);
      }
    
      // getPassedCount(): number {
      //   return this.allQuestionsData.questionContentDto.Table.filter((tc: TestCaseDto) => tc.correct).length;
      // }
    
      // getFailedCount(): number {
      //   return this.allQuestionsData.questionContentDto.Table.filter((tc: TestCaseDto) => 
      //     tc.testCaseStatus === 'FAILED'
      //   ).length;
      // }
    
      parseExpectedOutput(expectedOutput: string): string {
        try {
          // Remove quotes and handle escaped characters
          return JSON.parse(expectedOutput).trim();
        } catch {
          return expectedOutput.trim();
        }
      }
}
